import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import store from "./store";
import VModal from 'vue-js-modal';
import {BootstrapVue} from 'bootstrap-vue';
import {Modal, VoerroModal} from '@voerro/vue-modal';
import router from './router';
import cookies from 'vue-cookies';
import {convertDotToCommaInNumber, numberToHumanReadableHours} from "@/util/FormattingUtil";
import {toDayMonthYearHoursMinutesSeconds, toMonthNameWithYear, toYear} from "@/util/DateUtil";
import "./plugins/veeValidateExtensions";

Vue.use(VueRouter);
Vue.use(VModal, {dynamic: true, dynamicDefaults: {clickToClose: true}, dialog: true});
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.component('modal', Modal);
window.VoerroModal = VoerroModal;
Vue.use(cookies);
Vue.prototype.$JWT_COOKIENAME = 'PITA_AUTH';


Vue.filter('convertDotToCommaInNumber', convertDotToCommaInNumber);
Vue.filter('numberToHumanReadableHours', numberToHumanReadableHours);
Vue.filter('toMonthNameWithYear', toMonthNameWithYear);
Vue.filter('toDayMonthYearHoursMinutesSeconds', toDayMonthYearHoursMinutesSeconds);
Vue.filter('toYear', toYear);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
